import { render } from "./PageError.vue?vue&type=template&id=359de638&scoped=true"
import script from "./PageError.vue?vue&type=script&lang=js"
export * from "./PageError.vue?vue&type=script&lang=js"

import "./PageError.vue?vue&type=style&index=0&id=359de638&scoped=true&lang=css"

import exportComponent from "/var/www/hrm-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359de638"]])

export default __exports__